((QuickShop, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.addToCart = $('.js-add-to-cart');
    $dom.price = $('.js-price');
    $dom.styledSelects = $('.js-style-select');
  };

  const initQSProductSlider = () => {
    $('.quickshop-product-slider').slick({
      dots: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      asNavFor: '.product-thumbnails',
      responsive: [
        {
          breakpoint: 1021,
          settings: {
            dots: false,
          },
        },
      ],
    });
  };

  const initQSProductNav = () => {
    $('.product-thumbnails').slick({
      dots: false,
      arrows: false,
      mobileFirst: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      vertical: true,
      asNavFor: '.quickshop-product-slider',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1021,
          settings: {
            dots: false,
          },
        },
      ],
    });
  };

  let currentProductHandle = '';

  const changedVariant = ($selectOption) => {
    const selectedVariant = $selectOption.val();
    const $optionGroups = $('.js-product-option-group');
    const variants = {};
    let variantIsOutOfStock = false;

    $selectOption.closest('.js-product-option-group').attr('data-variant', selectedVariant);
  };

  const changedBundleVariant = ($selectOption) => {
    const sku = $selectOption.val();
    const $parent = $selectOption.closest('.js-product-option-group');
    const $bundleProducts = $parent.find('.js-bundle-product');
    const giftItem = $('.js-gift-option').val();
    const skuArray = [];
    $selectOption.closest('.js-bundle-product').attr('data-sku', sku);

    $bundleProducts.each((index, product) => {
      const productSku = $(product).attr('data-sku');

      if (productSku) {
        skuArray.push(productSku.toLowerCase());
      }
    });

    if (giftItem) {
      skuArray.push(giftItem.toLowerCase());
    }

    const $variantSelect = $parent.find('.js-variant-select');
    const reformattedSKU = skuArray.join(';').split('').sort().join('');

    $variantSelect.find('option').each((index, option) => {
      const $option = $(option);
      const optionString = $option.text().toLowerCase().replace('- sold out', '').trim().split('').sort().join('');

      if (reformattedSKU === optionString) {
        $variantSelect.val($option.val());
        $variantSelect.trigger('change');
        setBundleVariantAvailability($variantSelect);
      }
    });
  };
  const changeHeight = () => {
    //adjust height of the line item container if there is the promo bar
    const promoMessage = $('.inline-cart-promo-message');
    const lineItemContainer = $('.inline-cart .line-items-container');
    const containerHeight = 550;
    const promoHeight = promoMessage.innerHeight();
    let height = lineItemContainer.innerHeight();

    if (promoMessage.length > 0) {
      height = containerHeight - promoHeight;
    }
    lineItemContainer.css('height', height);
  };

  const setBundleVariantAvailability = (variantSelect) => {
    const $variant = $(variantSelect.context.closest('.product-options__bundle'));
    const $label = $variant.find('.input-wrapper__label');
    const lowStock = $variant.find('.js-bundle-variant-select').find(':selected').is('[data-is-low-in-stock]');

    if (lowStock) {
      if (!$label.find('.product-options__availability').length) {
        $variant.addClass('is-low-in-stock');
        $label.append('<span class="product-options__availability">Low in Stock</span>');
      }
    } else {
      $variant.removeClass('is-low-in-stock');
      $label.find('.product-options__availability').remove();
    }
  };

  const prodArry = [];
  const itemArry = [];
  let item = {};
  const addedToCart = (
    $form = null,
    $productGroups = null,
    productGroupsCount = null,
    $productFreeSamplesGroups = null,
    productFreeSamplesGroupsCount = null
  ) => {
    $form = $form ? $form : $('.js-product-form');
    $productGroups = $productGroups ? $productGroups : $('.js-product-option-group');
    productGroupsCount = productGroupsCount ? productGroupsCount : $productGroups.length;
    $productFreeSamplesGroups = $productFreeSamplesGroups
      ? $productFreeSamplesGroups
      : $('.js-product-freesamples-option-group');
    productFreeSamplesGroupsCount = productFreeSamplesGroupsCount
      ? productFreeSamplesGroupsCount
      : $productFreeSamplesGroups.length;

    let totalATCRequests = productGroupsCount + productGroupsCount * productFreeSamplesGroupsCount;
    let atcRequestIndex = 0;
    let errors = '';

    const addItemToCart = (_variantId, _quantity, _properties) => {
      CartJS.addItem(_variantId, _quantity, _properties, {
        success: function (data) {
          jQuery.each(data.options_with_values, function (i) {
            const optionName = data.options_with_values[i].name;
            const optionValue = data.options_with_values[i].value;
            item = {
              item_id: data.variant_id,
              shopify_product_id: data.product_id,
              shopify_variant_id: data.variant_id,
              shopify_sku: data.sku,
              shopify_handle: data.handle,
              item_name: data.title,
              affiliation: Shopify.shop,
              currency: Shopify.currency.active,
              item_brand: data.vendor,
              item_category: data.product_type,
              item_list_id: 'product',
              item_list_name: 'product',
              item_variant: data.variant_title,
              [optionName]: optionValue,
              price: data.price / 100,
            };
          });
          data = {
            name: data.title,
            id: data.id,
            productId: data.product_id,
            variantId: data.variant_id,
            price: data.price / 100,
            brand: data.vendor,
            sku: data.sku,
            variant: data.variant_title,
            quantity: 1,
            category: data.product_type,
          };
          atcRequestIndex++;
          itemArry.push(item);
          prodArry.push(data);
          if (atcRequestIndex === totalATCRequests && !errors) {
            InlineCart.toggle('show');
          }

          window.setTimeout(function () {
            InlineCart.discountGWP(0);
          }, 3000);
        },
        error: (error) => {
          atcRequestIndex++;
          if (error.status === 422 && error.responseJSON.description.indexOf('All') === 0) {
            if (errors.indexOf('Not enough items in stock.') === -1) {
              errors += 'Not enough items in stock. ';
            }
          } else {
            if (errors.indexOf('Could not add to cart, please try again.') === -1) {
              errors += 'Could not add to cart, please try again. ';
            }
          }

          if (atcRequestIndex === totalATCRequests) {
            alert(errors);
          }
        },
      });
    };

    const addSamples = ($productSamplesGroups, variant, productName, productGroupIndex, productQuantityInCart) => {
      $productSamplesGroups.each((productFreeSampleIndex, productFreeSampleGroup) => {
        const $productFreeSampleGroup = $(productFreeSampleGroup);
        const productFreeSampleVariantId = $productFreeSampleGroup.attr('data-variant');
        const productFreeSampleProperties = {
          _free_sample_for_variant_id: variant,
          _free_sample_for_product: productName,
        };
        let propertiesQuantity, propertiesIndex, lineItemProperties;
        const propertiesChosen = {
          _chosen_by_customer: 'Yes',
        };

        if (productFreeSampleVariantId) {
          propertiesQuantity = {
            _free_sample_for_quantity: productQuantityInCart + productGroupIndex + 1,
          };
          propertiesIndex = {
            _free_sample_index: productFreeSampleIndex + 1,
          };
          lineItemProperties = { ...productFreeSampleProperties, ...propertiesQuantity, ...propertiesIndex };
          if (0 === productGroupIndex) {
            lineItemProperties = {
              ...productFreeSampleProperties,
              ...propertiesQuantity,
              ...propertiesIndex,
              ...propertiesChosen,
            };
          }
          addItemToCart(productFreeSampleVariantId, 1, lineItemProperties);
        }
      });
    };

    if (productGroupsCount === 0) {
      const variantId = $('.js-single-product-variant').val();
      const quantity = $('.js-product-quantity').val();
      const properties = {};

      if ($productFreeSamplesGroups.length > 0) {
        properties['_has_free_samples'] = true;
      }

      CartJS.addItem(variantId, quantity, properties, {
        success: (data) => {
          jQuery.each(data.options_with_values, function (i) {
            const optionName = data.options_with_values[i].name;
            const optionValue = data.options_with_values[i].value;
            item = {
              item_id: data.variant_id,
              shopify_product_id: data.product_id,
              shopify_variant_id: data.variant_id,
              shopify_sku: data.sku,
              shopify_handle: data.handle,
              item_name: data.product_title,
              affiliation: Shopify.shop,
              currency: Shopify.currency.active,
              item_brand: data.vendor,
              item_category: data.product_type,
              item_list_id: 'product',
              item_list_name: 'product',
              item_variant: data.variant_title,
              [optionName]: optionValue,
              price: data.price / 100,
            };
          });
          data = {
            name: data.product_title,
            id: data.id,
            productId: data.product_id,
            variantId: data.variant_id,
            price: data.price / 100,
            brand: data.vendor,
            sku: data.sku,
            variant: data.variant_title,
            quantity: 1,
            category: data.product_type,
          };
          InlineCart.toggle('show');
          itemArry.push(item);
          prodArry.push(data);
          window.setTimeout(function () {
            InlineCart.discountGWP(0);
          }, 3000);
        },
        error: (error) => {
          if (error.status === 422 && error.responseJSON.description.indexOf('All') === 0) {
            alert('Not enough items in stock.');
            return;
          }

          alert('Could not add to cart, please try again.');
        },
      });

      if ($productFreeSamplesGroups.length > 0) {
        let variantLineItemInCart = CartJS.cart.items.find((item) => {
          return item.id == variantId;
        });
        let productQuantityInCart = typeof variantLineItemInCart !== 'undefined' ? variantLineItemInCart.quantity : 0;
        const productName = $form.closest('.product-form').find('meta[itemprop="name"]').attr('content');

        addSamples($productFreeSamplesGroups, variantId, productName, 0, productQuantityInCart);
      }

      changeHeight();
      return;
    }

    $productGroups.each((productGroupIndex, productGroup) => {
      const $productGroup = $(productGroup);
      const quantity = $productGroup.attr('data-bundle-qty') || 1;
      const $bundleProducts = $productGroup.find('.js-bundle-product');
      const variantId = $productGroup.attr('data-variant');
      let properties = {};

      $bundleProducts.each((index, product) => {
        const $product = $(product);
        const $productSelect = $product.find('.js-bundle-variant-select');
        const productName = $product.attr('data-name');
        let productOption = '';
        const obj = {};
        if ($productSelect.length) {
          const productValue = $productSelect.val();
          productOption = $productSelect.find('[value=' + productValue + ']').text();
        }
        if (properties[productName]) {
          //if item already exists in bundle object, append "(xIndex)" to the key
          obj[productName + ' (' + (index + 1) + ')'] = productOption;
        } else {
          obj[productName] = productOption;
        }
        properties = { ...properties, ...obj };
      });

      if (variantId) {
        if ($productFreeSamplesGroups.length > 0) {
          properties['_has_free_samples'] = true;
        }

        addItemToCart(variantId, quantity, properties);

        let variantLineItemInCart = CartJS.cart.items.find((item) => {
          return item.id == variantId;
        });
        let productQuantityInCart = typeof variantLineItemInCart !== 'undefined' ? variantLineItemInCart.quantity : 0;
        const productName =
          $form.closest('.product-form').find('meta[itemprop="name"]').attr('content') +
          ' - ' +
          $form.find('.js-variant-select option:selected').attr('data-variant-title');

        addSamples($productFreeSamplesGroups, variantId, productName, productGroupIndex, productQuantityInCart);
      }
    });

    dataLayer.push({
      event: 'addToCart',
      event_id: new Date().getTime() + '.' + Math.random().toString(36).substring(5),
      ecommerce: {
        currencyCode: Shopify.currency.active,
        items: itemArry,
        add: {
          actionField: { list: 'QuickShop', list_location: 'isHome' },
          products: prodArry,
        },
      },
    });
  };

  const initBundleSelection = () => {
    $('.js-bundle-variant-select').trigger('change');
  };

  const initSelectricStyles = () => {
    $('.js-variant-select').selectric({});
    $('.js-bundle-variant-select').selectric({});
    $('.js-pdpfreesample-variant-select').selectric({});
    $('.js-gift-option').selectric({});
  };

  const bindQuickShopActions = () => {
    $('[add-to-cart]').on('click', (event) => {
      event.preventDefault();
      addedToCart();
      prodArry.length = 0;
      Modal.hide();
    });

    $('.js-product-option-group-container').on('change', '.js-variant-select', (event) => {
      const $self = $(event.currentTarget);
      changedVariant($self);
    });

    $('.js-product-freesample-group-container').on('change', '.js-pdpfreesample-variant-select', (event) => {
      const $self = $(event.currentTarget);
      $self.closest('.js-product-freesamples-option-group').attr('data-variant', $self.val());
    });

    $('.js-product-option-group-container').on('change', '.js-bundle-variant-select', (event) => {
      const $self = $(event.currentTarget);
      changedBundleVariant($self);
    });

    $('.js-gift-option').on('change', () => {
      initBundleSelection();
    });

    $('.add-to-bundle').on('click', function () {
      const $btn = $(this);
      const productId = $btn.data('product-id');
      const $productGroups = $('.js-product-option-group');
      const productGroupsCount = $productGroups.length;
      const $productFreeSamplesGroups = $('.js-product-freesamples-option-group');
      // const productFreeSamplesGroupsCount = $productFreeSamplesGroups.length;
      const productTitle = $('h1.page-title[itemprop="name"]').text().trim();
      let $variantSelect = '';
      let $selectedOption = '';
      let variantId = '';
      let variantTitle = '';

      const freeSamples = $productFreeSamplesGroups.length
        ? $.map($productFreeSamplesGroups, (item) => item.dataset.variant)
        : [];

      const $priceEl = $('.js-price');
      let productPrice = null;

      if ($priceEl.length && $priceEl.data('price')) {
        productPrice = parseFloat($priceEl.data('price')) / 100;
      } else {
        productPrice = $priceEl.text().trim();
      }
      if (productGroupsCount > 0) {
        $variantSelect = $('.js-variant-select');
        $selectedOption = $variantSelect.find('option:selected');
        variantId = $selectedOption.val();
        variantTitle = $selectedOption.data('variant-title');
      } else {
        $variantSelect = $('.js-single-product-variant');
        $selectedOption = $variantSelect.find('option:selected');
        variantId = '';
        variantTitle = '';
      }

      let currentSlideImage = document.querySelector('.slick-slide.slick-active img');
      let imageUrl = '';

      if (currentSlideImage) {
        imageUrl = currentSlideImage.getAttribute('src');
      } else {
        // Fallback: try to get first image inside the slider as a safe fallback
        const firstImage = document.querySelector('.quickshop-product-slider img');
        imageUrl = firstImage ? firstImage.getAttribute('src') : '';
        console.warn('slick-current image not found, using fallback image:', imageUrl);
      }

      const bundleItem = {
        id: productId,
        price: productPrice,
        title: productTitle,
        variantTitle: variantTitle,
        variantId: variantId,
        handle: currentProductHandle,
        imageUrl: imageUrl,
        quantity: 1,
        uniqueId: `${variantId}-${new Date().getTime()}`,
        freeSamples,
      };

      // Add to localStorage
      addToBundle(bundleItem);
      Modal.hide();
    });
  };

  const bindUIActions = () => {
    $(document).on('click', '[quick-shop],[select-flavors]', (event) => {
      event.preventDefault();
      const linkUrl = $(event.currentTarget).attr('product-handle');
      currentProductHandle = linkUrl;
      const isBundle = $(event.currentTarget).data('bundle');
      const fetchUrl = isBundle
        ? `/products/${linkUrl}/?view=quickshop&bundle=true`
        : `/products/${linkUrl}/?view=quickshop`;

      $.get(fetchUrl).done((result) => {
        $('[quickshop-content]').html(result);
        Modal.show('quickshop');
        initSelectricStyles();
        // yotpo.initWidgets();
        bindQuickShopActions();
        initQSProductSlider();
        initQSProductNav();
        $('.quickshop-product-slider').slick('setPosition');
        $('.slick-current.slick-active').trigger('click');
        if (isBundle) {
          $('[add-to-cart]').addClass('display-none');
          $('.qs-red-link').addClass('display-none');
          $('.rewards-points-callout').addClass('display-none');
          $('#shopmessage-checkbox').addClass('display-none');
          $('.add-to-bundle').removeClass('display-none');
        } else {
          $('[add-to-cart]').removeClass('display-none');
          $('.qs-red-link').removeClass('display-none');
          $('#shopmessage-checkbox').removeClass('display-none');
          $('.rewards-points-callout').removeClass('display-none');
          $('.add-to-bundle').addClass('display-none');
        }
      });
    });
  };

  QuickShop.init = () => {
    cacheDom();
    bindUIActions();
  };

  QuickShop.addedToCart = addedToCart;
})((window.QuickShop = window.QuickShop || {}), jQuery);
